module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/diners_club-3ae195c7254fbbd6b2b0aa52c2ed4c2e.png";